/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { UserContext } from "../../contexts";

@Injectable()
export class HttpBearerTokenInterceptor implements HttpInterceptor {
  private readonly userContext = inject(UserContext);

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.userContext.userToken) {
      request = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${this.userContext.userToken.value}`
        }
      });
    }

    return next.handle(request);
  }
}
